import { Box } from '@oresundsbron/design-system';
import Image from 'next/image';
import { RichText } from '../../components/RichText';
import { RichText as RichTextType } from '@oresundsbron/api';
import { ContactInformation as ContactInformationType } from '@oresundsbron/api';
import { useTranslation } from 'next-i18next';

interface ContactInformationProps {
  heading: string | undefined;
  description?: RichTextType | undefined;
  contacts: ContactInformationType[];
}

const ContactInformation: React.FC<ContactInformationProps> = ({
  heading,
  description,
  contacts,
}) => {
  const { t } = useTranslation(['common']);
  return (
    <Box className="mb-12 flex flex-col gap-3">
      <Box className="w-full sm:w-1/2">
        {heading && (
          <h3 className=" pb-3 text-xl font-medium sm:text-[1.5rem]">
            {heading}
          </h3>
        )}
        {description !== null && (
          <Box className="pb-6">
            <RichText content={description}></RichText>
          </Box>
        )}
      </Box>
      <Box className="grid grid-cols-1 gap-y-6">
        {contacts &&
          contacts.map((contact, index) => (
            <Box
              key={index}
              className="flex flex-col gap-3 sm:flex-row sm:items-center"
            >
              {contact.image && (
                <Box className="relative h-40 w-40 overflow-hidden rounded-full">
                  {contact.image && (
                    <Image
                      fill
                      sizes="(max-width: 768px) 50vw,20vw"
                      src={contact.image.url}
                      quality={50}
                      title={contact.image.description || contact.title}
                      alt={contact.image.description || contact.title}
                      style={{
                        objectFit: 'cover',
                        aspectRatio: '16/10',
                      }}
                    />
                  )}
                </Box>
              )}
              <Box>
                <Box className="flex flex-col">
                  {contact.title && <span>{contact.title}</span>}
                  {contact.subtitle && (
                    <span className="text-neutral-600">{contact.subtitle}</span>
                  )}
                  {contact.address !== null && (
                    <RichText content={contact.address}></RichText>
                  )}
                </Box>
                <Box className="flex flex-col">
                  <span>
                    <span className="font-semibold">
                      {t('form.labels.email')}:
                    </span>{' '}
                    <a
                      className="cursor-pointer underline hover:text-primary-700"
                      href={`mailto:${contact.email}`}
                    >
                      {contact.email}
                    </a>
                  </span>
                  <span>
                    <span className="font-semibold">
                      {t('form.labels.phone')}:
                    </span>{' '}
                    <a
                      className="cursor-pointer underline hover:text-primary-700"
                      href={`tel:${contact.phoneNumber}`}
                    >
                      {contact.phoneNumber}
                    </a>
                  </span>
                </Box>
              </Box>
            </Box>
          ))}
      </Box>
    </Box>
  );
};

export default ContactInformation;
